import React from "react";
import Detail from "../components/Detail";
import Footer from "../components/Footer";
import Navigation from "../components/Navigation";

function DetailMovie() {
  return (
    <>
      <Navigation />
      <Detail />
      <Footer />
    </>
  );
}

export default DetailMovie;
